import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDcI2LE9PNKrOoVNocGYx5DFkRXMT1Ee9o",
  authDomain: "abacusinoice.firebaseapp.com",
  projectId: "abacusinoice",
  storageBucket: "abacusinoice.firebasestorage.app",
  messagingSenderId: "583194228903",
  appId: "1:583194228903:web:b8809f1c98f4c73d66c382",
  measurementId: "G-LHS2JYTCMN"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const functions = getFunctions(app);
const functionsJhb = getFunctions(app, 'africa-south1');
const storage = getStorage(app);

export { app, db, auth, provider, functions, functionsJhb, storage };
